// extracted by mini-css-extract-plugin
export var childrenWrapper = "_layout-module--childrenWrapper--06d2e";